import { JSONObject } from '../../types';
import { DockConfigurationSchema } from '../index';

export const ValidateMiddleware = async (config: JSONObject) => {
  return DockConfigurationSchema.parse(config);
};
